import { TbX } from 'react-icons/tb';

import { Button } from '@cccom/ui/src/components/shadcn/button';

type DevModeBadgeProps = { setDevMode: (devMode: boolean) => void };

export function DevModeBadge({ setDevMode }: DevModeBadgeProps) {
  return (
    <Button
      variant="ghost"
      className="fixed bottom-0 right-0 z-50 m-7 cursor-pointer rounded-lg border-2 border-gray-400 bg-white px-4 py-2 shadow-lg hover:border-gray-600 hover:bg-gray-100"
      onClick={() => setDevMode(false)}
    >
      <div className="flex items-center gap-2">
        <p className="animate-spin-slow select-none bg-gradient-to-t from-red-500 via-blue-500 via-green-500 via-yellow-500 to-purple-500 bg-clip-text text-base font-bold text-transparent">
          Dev Mode
        </p>
        <TbX />
      </div>
      <style>
        {`
                @keyframes spin-slow {
                  0% { filter: hue-rotate(0deg); }
                  100% { filter: hue-rotate(360deg); }
                }
                .animate-spin-slow {
                  animation: spin-slow 3s linear infinite;
                }
              `}
      </style>
    </Button>
  );
}
